import Rellax from 'rellax';

let el = '.js-rellax';

function init() {
  // check for el
  if (!document.body.contains(document.querySelector(el))) {
    return;
  }

  let rellax = new Rellax(el, { // eslint-disable-line
    speed: -2,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
  });
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/rellax.js